import { useSelector } from "react-redux";
import { useBusinessTypeQuery, useGetChannelTypeQuery, useGetGroupClassificationQuery, useModeOfPaymentQuery, useTypeOfGroupQuery } from "../../api/gms/group-category/group-category-api";
import { useGetProposalQuery } from "../../api/gms/proposal/proposal-api";
import { selectUserId } from "../../features/auth/auth-slice";
import { useGetUserInfoQuery } from "../../api/user/user-api";
import { useGetUserListQuery, useLazyGetUserListQuery } from "../../api/it/account/account-api";
import { useGetDepartmentTypeQuery, useGetLocationTypeQuery, useGetRoleTypeQuery } from "../../api/it/account-category/account-category-api";

export function useRefetchQuery() {

    const userId = useSelector(selectUserId);
    const { refetch: refetchGroupClassification } = useGetGroupClassificationQuery();
    const { refetch: refetchBusinessType } = useBusinessTypeQuery();
    const { refetch: refetchTypeOfGroup } = useTypeOfGroupQuery();
    const { refetch: refetchModeOfPayment } = useModeOfPaymentQuery();
    // const { refetch: refetchGetProposal } = useGetProposalQuery({});
    const { refetch: refetchUserInfo } = useGetUserInfoQuery({userId: userId!}, {skip: !userId});
    // const { refetch: refetchGetUserList } = useGetUserListQuery(undefined, {skip: true});
    // const [getUserList] = useLazyGetUserListQuery();
    const { refetch: refetchDepartment } = useGetDepartmentTypeQuery();
    const { refetch: refetchRoleType  } = useGetRoleTypeQuery();
    const { refetch: refetchLocationType } = useGetLocationTypeQuery();
    const { refetch: refetchChannelType } = useGetChannelTypeQuery();

    const refetchCreateProposal = async () => {
        await Promise.all([
            refetchGroupClassification(),
            refetchBusinessType(),
            refetchTypeOfGroup(),
            refetchModeOfPayment(),
            refetchChannelType(),
        ]);
    };

    const refetchProposalStatus = async () => {
        // await refetchGetProposal();
    };

    const refetchAccountSetting = async () => {
        await refetchUserInfo()
    }

    const refetchUserManagement = async () => {
        // await refetchGetUserList()
        // await getUserList();
    }

    const refetchNewAccount = async () => {
        await Promise.all([
            refetchDepartment(),
            refetchRoleType(),
            refetchLocationType(),
        ]);
    }

    return {
        refetchCreateProposal,
        refetchProposalStatus,
        refetchAccountSetting,
        refetchUserManagement,
        refetchNewAccount,
    };
}